// Polyfills for older browsers
import 'core-js/stable'
import 'whatwg-fetch'

import { createApp } from 'vue'
import './style.css'
import '@material-symbols/font-400/outlined.css'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import i18n from './plugins/i18n'
import { setupSEO } from './plugins/seo'

const app = createApp(App)

// 兼容旧模板/缓存代码：避免渲染期读取 sponsors 等未定义变量导致白屏
app.config.globalProperties.sponsors = []
app.config.globalProperties.visibleSponsors = []
app.config.globalProperties.sponsorsExpanded = false
app.config.globalProperties.hasMoreSponsors = false

app
  .use(router)
  .use(vuetify)
  .use(i18n)
  .mount('#app')

setupSEO(router)

;(async () => {
  try {
    const isNative = typeof window !== 'undefined' && window.Capacitor && typeof window.Capacitor.isNativePlatform === 'function' && window.Capacitor.isNativePlatform()
    if (isNative) {
      const mod = await import('./mobile/push')
      if (mod && typeof mod.initMobilePush === 'function') mod.initMobilePush(router)
    }
  } catch {}
})()
